import script from "./SauterDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./SauterDetail.vue?vue&type=script&setup=true&lang=js"

import "./SauterDetail.vue?vue&type=style&index=0&id=1f5509bc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1f5509bc"]])

export default __exports__